import { gql } from '@/shared/graphql/generated/cache';

export const boostChainflipBlocksDelayQuery = gql(/* GraphQL */ `
  query BoostChainflipBlocksDelayQuery($chain: ChainflipChain) {
    allBoostDelayChainflipBlocks(filter: { chain: { equalTo: $chain } }) {
      nodes {
        chain
        numBlocks
      }
    }
  }
`);
